gsap.registerPlugin(Draggable, ScrollTrigger, ScrollToPlugin);

$(document).ready(() => {
  let navState = false;
  const $html = $('html');
  let $header = $('.page-header');
  let $nav = $('.nav');
  let isObserver = true;
  let lastScrollTop = 0;
  let observer;

  if (
    !('IntersectionObserver' in window) ||
    !('IntersectionObserverEntry' in window) ||
    !('isIntersecting' in window.IntersectionObserverEntry.prototype)
  ) {
    isObserver = false;
    $('html').removeClass('is-observer');
  }

  if (isObserver) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -15% 0px' },
    );
  }

  function isTouchDevice() {
    const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    const mq = (query) => {
      return window.matchMedia(query).matches;
    };

    if (
      'ontouchstart' in window ||
      // eslint-disable-next-line no-undef
      (window.DocumentTouch && document instanceof DocumentTouch)
    ) {
      return true;
    }

    // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH
    const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join(
      '',
    );
    return mq(query);
  }

  if (isTouchDevice()) {
    $('html').addClass('is-touch');
  }

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  // function debounce(func, wait, immediate, ...args) {
  //   let timeout;
  //   return function () {
  //     const context = this;
  //     const later = function () {
  //       timeout = null;
  //       if (!immediate) func.apply(context, args);
  //     };
  //     const callNow = immediate && !timeout;
  //     clearTimeout(timeout);
  //     timeout = setTimeout(later, wait);
  //     if (callNow) func.apply(context, args);
  //   };
  // }

  function disableScrolling() {
    if ($(document).height() > $(window).height()) {
      const scrollTop = $('html').scrollTop()
        ? $('html').scrollTop()
        : $('body').scrollTop(); // Works for Chrome, Firefox, IE...
      $('html').addClass('disable-scrolling').css('top', -scrollTop);
    }
  }

  function enableScrolling() {
    const scrollTop = parseInt($('html').css('top'), 10);
    $('html').removeClass('disable-scrolling');
    $('html,body').scrollTop(-scrollTop);
  }

  function bindEvents() {
    $('.hamburger').on('click', () => {
      if (navState) {
        $header.removeClass('is-opened');
        $nav.removeClass('is-opened');
        enableScrolling();
      } else {
        $header.addClass('is-opened');
        $nav.addClass('is-opened');
        disableScrolling();
      }

      navState = !navState;
    });

    // FOCUS STYLING
    // Let the document know when the mouse is being used
    document.body.addEventListener('mousedown', () => {
      document.body.classList.remove('is-tab');
    });

    // Re-enable focus styling when Tab is pressed
    document.body.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') {
        document.body.classList.add('is-tab');
      }
    });

    // refresh scroll trigger on image load
    const $images = $('img');
    if ($images.length) {
      $images.each((i, img) => {
        if (img.complete) {
          ScrollTrigger.refresh();
        } else {
          img.addEventListener('load', () => ScrollTrigger.refresh());
        }
      });
    }
  }

  function initStickers() {
    const $draggable = $('.js-draggable');

    $draggable.each((i, el) => {
      const $container = $(el);
      const $stickers = $container.find('*[data-draggable]');

      if ($stickers.length) {
        Draggable.create($stickers, {
          type: 'x,y',
          edgeResistance: 0.8,
          bounds: $container[0],
          zIndexBoost: false,
        });
      }
    });
  }

  function initFeatured() {
    const $block = $('.featured-wrapper');
    if (!$block.length) return;

    ScrollTrigger.create({
      trigger: $block[0],
      start: 'top center',
      end: 'bottom center',
      onToggle: ({ isActive }) => {
        if (isActive) {
          document.body.classList.add('is-dark');
        } else {
          document.body.classList.remove('is-dark');
        }
      },
    });
  }

  function initHomeHero() {
    const $block = $('.hero');
    if (!$block.length) return;

    ScrollTrigger.create({
      trigger: $block[0],
      start: 'top top',
      end: 'bottom top',
      onEnter: () => {
        document.body.classList.add('is-dark');
      },
      onLeave: () => {
        document.body.classList.remove('is-dark');
      },
      onEnterBack: () => {
        document.body.classList.add('is-dark');
      },
    });
  }

  function initBrand() {
    const $block = $('.brand');
    if (!$block.length) return;

    ScrollTrigger.create({
      trigger: $block[0],
      start: 'top center',
      end: 'bottom center',
      onEnter: () => {
        document.body.classList.add('is-dark');
      },
      onLeaveBack: () => {
        document.body.classList.remove('is-dark');
      },
    });
  }

  function initFooter() {
    const $footer = $('.page-footer');
    const $logo = $footer.find('.page-footer__logo');
    const tl = gsap.timeline({
      repeat: -1,
      scrollTrigger: {
        trigger: $footer[0],
        start: 'top bottom',
        end: 'bottom top',
        toggleActions: 'play pause resume pause',
      },
    });

    ScrollTrigger.create({
      trigger: $footer[0],
      start: 'top 100px',
      end: 'bottom top',
      onToggle: ({ isActive }) => {
        if (isActive) {
          $header.addClass('is-dark');
        } else {
          $header.removeClass('is-dark');
        }
      },
    });

    tl.to($logo[0], {
      color: '#F3E9CC',
      duration: 1,
    })
      .to($logo[0], {
        color: '#8383E0',
        duration: 1,
      })
      .to($logo[0], {
        color: '#EAC15B',
        duration: 1,
      })
      .to($logo[0], {
        color: '#84C4B3',
        duration: 1,
      })
      .to($logo[0], {
        color: '#B9DDDD',
        duration: 1,
      });
  }

  function initLefovers() {
    const $block = $('.leftovers');

    if (!$block.length) return;
    const $hero = $block.find('.leftovers__hero');
    const $marquee = $block.find('.leftovers__marquee');

    gsap.to($marquee[0], {
      duration: 1,
      x: '-20%',
      scrollTrigger: {
        trigger: $hero[0],
        start: 'top top',
        end: 'bottom top',
        scrub: true,
        ease: 'power1.inOut',
      },
    });
  }

  function initProject() {
    const $project = $('.project');
    if (!$project.length) return;
    const $hero = $project.find('.project-hero');
    const $heroInner = $hero.find('.project-hero__inner');
    const $marquee = $heroInner.find('.project-hero__marquee');
    const $body = $('body');
    const isDark = $body.hasClass('is-dark');

    gsap.to($marquee[0], {
      duration: 1,
      x: '-30%',
      scrollTrigger: {
        trigger: $hero[0],
        start: 'top top',
        endTrigger: $heroInner[0],
        end: 'bottom top',
        scrub: true,
        ease: 'none',
      },
    });

    gsap.to($project[0], {
      scrollTrigger: {
        trigger: $hero[0],
        start: 'bottom center',
        end: '+=20',
        toggleActions: 'play none reverse none',
      },
      color: '#262626',
      backgroundColor: '#f9f8f5',
      onReverseComplete() {
        if (isDark) {
          $body.addClass('is-dark');
        }
      },
      onComplete() {
        if (isDark) {
          $body.removeClass('is-dark');
        }
      },
    });
  }

  function updateHeader() {
    const st = $(window).scrollTop();

    // scroll down
    if (st > lastScrollTop) {
      if (st > 50) {
        $header.addClass('is-scrolling');
      }
    } else {
      $header.removeClass('is-scrolling');
    }

    lastScrollTop = st <= 0 ? 0 : st;
  }

  /* FUNCTION CALLS */
  /* ============= */
  function initJS() {
    $header = $('.page-header');
    $nav = $('.nav');
    navState = false;

    bindEvents();
    initHomeHero();
    initStickers();
    initFeatured();
    initFooter();
    initBrand();
    initLefovers();
    initProject();

    if (isObserver) {
      $('.js-visibility').each((i, el) => {
        observer.observe(el);
      });
    }

    ScrollTrigger.refresh();
  }

  const $preloader = $('.preloader');
  const $svg = $preloader.find('svg');
  const preloaderTL = gsap
    .timeline({
      delay: 0.5,
      onComplete() {
        enableScrolling();
        $('html').scrollTop(0);
        initJS();

        // hide preloader
        if ($preloader.length) {
          gsap.to($preloader[0], {
            opacity: 0,
            onComplete() {
              // prepare prelaoder for the page navigation
              gsap.set($preloader[0], {
                opacity: 1,
                x: '-100%',
                visibility: 'hidden',
              });

              // hide logo
              gsap.set($svg[0], {
                visibility: 'hidden',
              });
            },
          });
        }

        // eslint-disable-next-line no-eval
        // eval($('#forminator-front-scripts-js-after').text());
      },
    })
    .pause();

  function initPreloader() {
    const $base = $preloader.find('.preloader__base');
    const $dots = $preloader.find('.preloader__dot');

    if (!$dots.length || !$base.length) {
      preloaderTL.play();

      return;
    }

    // const [dot1, dot2, dot3] = $dots.toArray();

    preloaderTL.fromTo(
      $base[0],
      {
        y: '60%',
        opacity: 0,
      },
      {
        duration: 0.75,
        y: 0,
        opacity: 1,
      },
    );

    $dots.each((key, dot) => {
      preloaderTL
        .fromTo(
          dot,
          {
            opacity: 0,
          },
          {
            opacity: 1,
            duration: 0.3,
          },
          '-=0.1',
        )
        .fromTo(
          dot,
          {
            y: '-115%',
          },
          {
            y: 0,
            duration: 0.4,
          },
          '-=0.15',
        );
    });

    preloaderTL.play();
  }

  function finishPageNavigation() {
    enableScrolling();
    $('html').scrollTop(0);
    initJS();

    // eslint-disable-next-line no-eval
    eval($('#forminator-front-scripts-js-after').text());
  }

  $(window).on('scroll', updateHeader);

  barba.init({
    prevent: ({ el }) => el.classList && el.classList.contains('ab-item'),
    transitions: [
      {
        name: 'default-transition',
        once() {
          // Once on page load
          // disable scrolling if it's not disables yet
          if (!$html.hasClass('disable-scrolling')) {
            disableScrolling();
          }

          // init prelaoder and play animation once
          initPreloader();
        },
        leave() {
          // show preloader
          gsap.set($preloader[0], {
            visibility: 'visible',
          });

          return new Promise((resolve) => {
            gsap.to($preloader[0], {
              x: '0',
              onComplete() {
                resolve();
              },
            });
          });
        },
        afterLeave(data) {
          // disable scrolling if it's not disables yet
          if (!$html.hasClass('disable-scrolling')) {
            disableScrolling();
          }

          // kill all scroll triggers
          ScrollTrigger.getAll().forEach((el) => el.kill());

          // updat body classes
          const nextHtml = data.next.html;
          const responseBody = nextHtml.replace(
            /(<\/?)body( .+?)?>/gi,
            '$1notbody$2>',
            nextHtml,
          );
          const bodyClasses = $(responseBody).filter('notbody').attr('class');
          $('body').attr('class', bodyClasses || '');
        },
        after() {
          // after everything when old container removed
          // hide preloader
          gsap.to($preloader[0], {
            x: '100%',
            onComplete() {
              // prepare preloader for the next animation
              gsap.set($preloader[0], {
                x: '-100%',
                visibility: 'hidden',
              });
            },
          });

          finishPageNavigation();
        },
      },
    ],
  });
});
